// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_INSECTOIDS = [{
  id: 'insectoids_black',
  factionId: FACTIONS.INSECTOIDS,
  name: 'Чистильщик',
  priceNumens: 5000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.PURPLE,
  ]
}, {
  id: 'insectoids_city',
  factionId: FACTIONS.INSECTOIDS,
  name: 'Архитектор улья',
  priceNumens: 28000,
  skinRank: 2,
}, {
  id: 'insectoids_eggs',
  factionId: FACTIONS.INSECTOIDS,
  name: 'Мать улья',
  priceNumens: 60000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'insectoids_gold_legacy',
  factionId: FACTIONS.INSECTOIDS,
  name: 'Чёрный скарабей',
  priceNumens: 80000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'insectoids_ruby_legacy',
  factionId: FACTIONS.INSECTOIDS,
  name: 'Фараон роя',
  priceCrystals: 300,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
